import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { SentEmail } from "../../../../../api/types/emailsTypes";
import { contactEmailsColumns } from "./contactEmailsTableDefinitions";

interface Props {
  emails: SentEmail[];
}

const ContactEmailsTable = ({ emails }: Props) => {
  return (
    <DataGrid<SentEmail>
      noRowsText="No emails"
      columns={contactEmailsColumns}
      rows={emails}
      multilineRows
      disableColumnSorting
    />
  );
};

export default ContactEmailsTable;
